import { BlockProvider, FCC } from "@dgs/core";

export const PMBlockProvider: FCC = ({ children }) => {
	return <BlockProvider isPublic={true}>{children}</BlockProvider>;
};
